import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/stores/userStore';
import { Footer } from '@/components/Footer';

export default function Register() {
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { userSecret, setUserId, setUserName: saveUserName, setRegistered } = useUserStore();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userName.trim()) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/users/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userSecret, userName: userName.trim() }),
      });

      const data = await response.json();

      if (response.ok) {
        setUserId(data.userId);
        saveUserName(data.userName);
        setRegistered(true);
        navigate('/');
      } else if (response.status === 409) {
        // Already registered, update local state
        setUserId(data.userId);
        saveUserName(data.userName);
        setRegistered(true);
        navigate('/');
      } else {
        setError(data.error || 'Failed to register');
      }
    } catch (err) {
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-primary mb-2">
            Welcome to <span className="text-lime-400">YT Music Sync</span>
          </h1>
          <p className="text-secondary">
            Choose a username to get started
          </p>
        </div>

        <div className="card">
          <form onSubmit={handleRegister} className="space-y-6">
            <div>
              <label htmlFor="userName" className="block text-sm font-bold text-primary mb-2">
                Your Name
              </label>
              <input
                type="text"
                id="userName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Enter your name"
                className="input"
                required
                autoFocus
                maxLength={50}
              />
            </div>

            {error && (
              <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 p-3 rounded-lg">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !userName.trim()}
              className="btn-primary w-full"
            >
              {loading ? 'Setting up...' : 'Get Started'}
            </button>
          </form>
        </div>

        <Footer />
      </div>
    </div>
  );
}
